import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './DocsSidebar.css';
import expandIcon from '../assets/expand.png';
import collapseIcon from '../assets/collapse.png';

const DocsSidebar = () => {
  const [isModesExpanded, setIsModesExpanded] = useState(false);
  const location = useLocation();

  const toggleModes = () => {
    setIsModesExpanded(!isModesExpanded);
  };

  useEffect(() => {
    // If the current route contains "modes", expand the section
    if (location.pathname.includes('modes')) {
      setIsModesExpanded(true);
    }
  }, [location]);

  return (
    <aside className="docs-sidebar">
      <ul>
        <li>
          <NavLink to="introduction" end> Introduction </NavLink>
        </li>
        <li>
          <button className="section-toggle" onClick={toggleModes}>
            Modes
            <img 
              src={isModesExpanded ? expandIcon : collapseIcon} 
              alt={isModesExpanded ? "Collapse" : "Expand"}
              className="toggle-icon"
            />
          </button>
          <ul className={`modes-sublist ${isModesExpanded ? 'expanded' : 'collapsed'}`}>
            <li>
              <NavLink to="modes" end> Overview </NavLink>
            </li>
            <li>
              <NavLink to="modes/gestures"> Gestures Examples </NavLink>
            </li>
            <li>
              <NavLink to="modes/blinks"> Blinks Examples </NavLink>
            </li>
          </ul>
        </li>
        <li>
          <NavLink to="instructions" end> Types of Instructions </NavLink>
        </li>
        <li>
          <NavLink to="traingestures" end> Training Gestures </NavLink>
        </li>
        <li>
          <NavLink to="mouse" end> Moving the Cursor </NavLink>
        </li>
        <li>
          <NavLink to="blinks" end> Blinks Detector </NavLink>
        </li>
      </ul>
    </aside>
  );
};

export default DocsSidebar;
